import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Accordion from '../../../components/common/Accordion';
import AccordionDarkHeader from '../../../components/common/Accordion/AccordionDarkHeader';
import {
  makeGetCompetitionEvents,
  makeGetCompetitionMarketGroups,
  makeGetCompetitionName
} from '../../../modules/events/selectors';

export const Competition = ({
  competitionId,
  competitionName,
  defaultExpanded,
  eventIds,
  marketGroups,
  header,
  event,
  onAccordionChange
}) => (
  <Accordion
    header={AccordionDarkHeader}
    headerText={competitionName}
    className="competition"
    id={competitionId}
    defaultExpanded={defaultExpanded}
    onChange={onAccordionChange}
  >
    {marketGroups.map(marketGroup => (
      <React.Fragment key={marketGroup}>
        {header(marketGroup)}
        <div className="competition__events">
          {eventIds.map(eventId => event(eventId, marketGroup))}
        </div>
      </React.Fragment>
    ))
    }
  </Accordion>
);

Competition.propTypes = {
  competitionId: PropTypes.string.isRequired,
  competitionName: PropTypes.string.isRequired,
  defaultExpanded: PropTypes.bool.isRequired,
  eventIds: PropTypes.object.isRequired,
  marketGroups: PropTypes.instanceOf(List),
  header: PropTypes.func,
  event: PropTypes.func,
  onAccordionChange: PropTypes.func
};

Competition.defaultProps = {
  marketGroups: new List(['90 Minutes']),
  header: () => undefined,
  event: eventId => (<div key={eventId}>{eventId}</div>),
  onAccordionChange: () => undefined
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getCompetitionMarketGroups = makeGetCompetitionMarketGroups();
  const getCompetitionName = makeGetCompetitionName();
  const getCompetitionEvents = makeGetCompetitionEvents();
  return (state) => ({
    marketGroups: getCompetitionMarketGroups(state, initialProps),
    competitionName: getCompetitionName(state, initialProps),
    eventIds: getCompetitionEvents(state, initialProps)
  });
};

export default connect(makeMapStateToProps)(Competition);
